export default "__VITE_ASSET__2DRwSWe0__"